import { render } from "./ClientsList.vue?vue&type=template&id=3e0a6e5a&scoped=true&xmlns%3Av-expand-transition=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ClientsList.vue?vue&type=script&lang=js"
export * from "./ClientsList.vue?vue&type=script&lang=js"

import "./ClientsList.vue?vue&type=style&index=0&id=3e0a6e5a&scoped=true&lang=css"
import "./ClientsList.vue?vue&type=style&index=1&id=3e0a6e5a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0a6e5a"]])

export default __exports__